enum ValidationStatusEnum {
  'VALIDATING' = 'validating',
  'ERROR' = 'error',
  'SUCCESS' = 'success',
  'INVALID' = 'invalid',
  'NONE' = 'none',
}

export default ValidationStatusEnum;
